import { gql } from '@apollo/client';

export const NEW_VEHICLE = gql`
  fragment CreateVehicle on Vehicle {
    id
    insurance
    plate
    model
    color
    category
    policyNumber
    isTrailer
    isActive
    accidentIDs
    ownership
    usage
    parentVehicleIDs
    childVehicleIDs
    vehicleCategoryIDs
    concessionIDs
    teamIDs
  }
`;
